module.exports = __webpack_public_path__ + "interactiveApp/KurzByk/media/8a loupana plec (top blade steaky).jpg";